import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Sprout, Lock } from "lucide-react";

export default function LoginPage() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      if (u.must_change_password) {
        nav("/infaq/ganti-sandi");
      } else if (u.role === "admin") {
        nav("/infaq/bendahara");
      } else {
        nav("/infaq/pj-kelas");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login gagal");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex flex-col items-center justify-center px-4">
      <Link to="/infaq" className="mb-6 flex items-center gap-2" data-testid="login-back-link">
        <div className="h-12 w-12 rounded-full bg-[#1B4D3E] flex items-center justify-center text-[#C59B27]">
          <Sprout size={22} />
        </div>
        <div className="text-xl font-bold text-[#1B4D3E]">INFAK KHAIRUL FALAH</div>
      </Link>
      <Card className="w-full max-w-md p-6 sm:p-8">
        <h1 className="text-2xl font-bold text-[#1B4D3E] mb-1">Masuk Pengurus</h1>
        <p className="text-sm text-[#64748B] mb-6">Khusus PJ kelas dan bendahara/admin.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" autoComplete="email" />
          </div>
          <div>
            <Label htmlFor="password">Kata Sandi</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#1B4D3E] hover:bg-[#143E32] text-white" data-testid="login-submit-btn">
            <Lock size={14} className="mr-2" /> {loading ? "Memproses..." : "Masuk"}
          </Button>
        </form>
        <p className="mt-6 text-xs text-[#94A3B8] text-center">
          Lupa kata sandi? Hubungi bendahara untuk pengaturan ulang.
        </p>
      </Card>
      <Link to="/infaq" className="mt-4 text-sm text-[#64748B] underline" data-testid="login-public-link">← Kembali ke halaman publik</Link>
    </div>
  );
}
